import React from 'react';
import './App.scss';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from "./redux/storeConfig/store";
import { Provider } from "react-redux";
import Toast from "./components/Toast/Toast";
import AppRoutes from './routes/AppRoutes';
import Loader from './components/Loader';
import CustomToast from './components/CustomToast/CustomToast';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <AppRoutes />
        <Loader />
        {/* <Toast /> */}
        <CustomToast message='' type='success'/>
      </PersistGate>
    </Provider>

  );
}

export default App;
